import { render, staticRenderFns } from "./shuttle.vue?vue&type=template&id=0d82859e&scoped=true&"
import script from "./shuttle.vue?vue&type=script&lang=js&"
export * from "./shuttle.vue?vue&type=script&lang=js&"
import style0 from "./shuttle.vue?vue&type=style&index=0&id=0d82859e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d82859e",
  null
  
)

export default component.exports